/**
 * VFX ligeros: bursts DOM + partículas Three opcionales.
 */
export class VfxController {
  constructor(layerEl) {
    this.layer = layerEl;
  }

  burst(x, y, color = '#ff9f1c') {
    if (!this.layer) return;
    const el = document.createElement('span');
    el.className = 'burst';
    el.style.left = `${x}px`;
    el.style.top = `${y}px`;
    el.style.setProperty('--burst', color);
    this.layer.appendChild(el);
    el.addEventListener('animationend', () => el.remove(), { once: true });
  }

  flashHud() {
    if (!this.layer) return;
    this.layer.classList.add('flash');
    setTimeout(() => this.layer.classList.remove('flash'), 160);
  }
}

/** Partícula Three.js mínima al recolectar. */
export function spawnPopParticles(THREE, parent, position) {
  const geo = new THREE.BufferGeometry();
  const count = 12;
  const positions = new Float32Array(count * 3);
  for (let i = 0; i < count; i += 1) {
    positions[i * 3] = position.x;
    positions[i * 3 + 1] = position.y;
    positions[i * 3 + 2] = position.z;
  }
  geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
  const mat = new THREE.PointsMaterial({ color: 0xffe66d, size: 0.04, transparent: true, opacity: 1 });
  const points = new THREE.Points(geo, mat);
  parent.add(points);

  const velocities = Array.from({ length: count }, () => ({
    x: (Math.random() - 0.5) * 0.8,
    y: Math.random() * 0.9,
    z: (Math.random() - 0.5) * 0.8,
  }));

  let life = 0.45;
  return {
    update(dt) {
      life -= dt;
      const attr = geo.getAttribute('position');
      for (let i = 0; i < count; i += 1) {
        attr.array[i * 3] += velocities[i].x * dt;
        attr.array[i * 3 + 1] += velocities[i].y * dt;
        attr.array[i * 3 + 2] += velocities[i].z * dt;
      }
      attr.needsUpdate = true;
      mat.opacity = Math.max(0, life / 0.45);
      if (life <= 0) {
        parent.remove(points);
        geo.dispose();
        mat.dispose();
        return false;
      }
      return true;
    },
  };
}
